module.exports = __webpack_public_path__ + "static/media/9-mobile.8c5f7998.jpg";